const removeWidthBounds = (html: string) => html.replace(/"width:.+px"/g, '')

const replaceImageHeight = (html: string) =>
  html.replace(/height:.+px/g, 'width:100%')

const replaceIframeWidth = (html: string) =>
  html.replace(/width=".+"/g, 'width="100%"')

const replaceIframeHeight = (html: string) =>
  html.replace(/height="[0-9]+"/g, 'style="width: 100%; height: 50vw;"')

const replaceOneBlock = (html: string, attachmentObj: any) => {
  var regexMatcher = new RegExp(
    `<table.+class="pdfWrapper"[\\s\\S]* ${attachmentObj.id} [\\s\\S]*?</table>`
  )
  const resultingPdfTag = `<object data="${attachmentObj.attachmentUri}" width="640" height="905"></object>`

  return html.replace(regexMatcher, resultingPdfTag)
}

const replacePdfContent = (attachments: any[]) => (html: string) => {
  return attachments.reduce(replaceOneBlock, html)
}

export const performReplacements = (html: string, attachments: any[]) =>
  replacePdfContent(attachments)(html)
